'use strict';

function normalizeRejectSelectionToken(value) {
  return String(value ?? '')
    .trim()
    .replace(/[^a-z0-9]+/gi, '')
    .toLowerCase();
}

function getRejectSelectionTokenAliases(value) {
  const text = String(value ?? '');
  return [
    text,
    text.replace(/foreign material/ig, 'Foreign Matter'),
    text.replace(/foreign matter/ig, 'Foreign Material'),
    text === 'Broken' ? 'isBroken' : ''
  ].map(normalizeRejectSelectionToken).filter(Boolean);
}

function isTruthyRejectValue(value) {
  if (value === null || value === undefined) return false;
  const normalized = String(value).trim().toLowerCase();
  if (!normalized || normalized === 'false' || normalized === '0' || normalized === '0.0') return false;
  if (normalized === 'true') return true;
  const numeric = Number(normalized);
  return Number.isNaN(numeric) ? false : numeric > 0;
}

function resolveSelectedRejectColumns(headerRow, snapshot) {
  const headerLookup = new Map();
  (headerRow || []).forEach((column, index) => {
    getRejectSelectionTokenAliases(column).forEach((token) => headerLookup.set(token, index));
  });
  const selectedKeys = Array.isArray(snapshot?.selectedKeys) ? snapshot.selectedKeys : [];
  const selectedLabels = Array.isArray(snapshot?.selectedLabels) ? snapshot.selectedLabels : [];
  const selectedIndexes = new Set();
  const unresolvedSelections = [];
  const selectionCount = Math.max(selectedKeys.length, selectedLabels.length);
  for (let selectionIndex = 0; selectionIndex < selectionCount; selectionIndex += 1) {
    const values = [selectedKeys[selectionIndex], selectedLabels[selectionIndex]].filter(Boolean);
    let resolved = false;
    for (const value of values) {
      for (const token of getRejectSelectionTokenAliases(value)) {
        const index = headerLookup.get(token);
        if (index !== undefined) {
          selectedIndexes.add(index);
          resolved = true;
        }
      }
    }
    if (!resolved && values.length > 0) unresolvedSelections.push(values[0]);
  }
  return { selectedIndexes: Array.from(selectedIndexes), unresolvedSelections };
}

function getSelectedRejectColumnIndexes(headerRow, snapshot) {
  return resolveSelectedRejectColumns(headerRow, snapshot).selectedIndexes;
}

function filterMeasurementRowsByRejectSelection(headerRow, rows, snapshot) {
  if (!snapshot || !Array.isArray(headerRow) || headerRow.length === 0) return rows;

  let rejectIndexes = headerRow.reduce((indexes, column, index) => {
    if (column === 'isBroken' || /^Reject_/i.test(column)) indexes.push(index);
    return indexes;
  }, []);
  if (rejectIndexes.length === 1 && headerRow[rejectIndexes[0]] === 'isBroken') {
    rejectIndexes = headerRow.slice(rejectIndexes[0]).map((_, offset) => rejectIndexes[0] + offset);
  }
  if (rejectIndexes.length === 0) return rows;

  const { selectedIndexes } = resolveSelectedRejectColumns(headerRow, snapshot);
  const selectedIndexSet = new Set(selectedIndexes);
  const unselectedIndexes = rejectIndexes.filter((index) => !selectedIndexSet.has(index));
  return (rows || []).filter((row) => {
    // A grain is included only when it has no unticked rejection category.
    // This also excludes a grain that has both selected and unselected rejects.
    return !unselectedIndexes.some((index) => isTruthyRejectValue(row?.[index]));
  });
}

module.exports = {
  filterMeasurementRowsByRejectSelection,
  getRejectSelectionTokenAliases,
  getSelectedRejectColumnIndexes,
  isTruthyRejectValue,
  normalizeRejectSelectionToken
};
